export default "__VITE_ASSET__6c732dc5__"